import ActionTile from './ActionTile';

// The "Add a connection" tile shown at the top of the workspace landing,
// section, and document-type-detail pages. Links to the /connections/add
// flow, where the user picks any app or document source. `redirectTo` is the
// absolute path that flow should return to. Logos are a mix of apps and storage
// so the single button reads as "any kind of source".
export default function ConnectSourceButton({ redirectTo }: { redirectTo: string }) {
  return (
    <ActionTile
      to={`/connections/add?redirect=${encodeURIComponent(redirectTo)}`}
      logos={['xero', 'drive', 'hubspot']}
      title="Add a connection"
      subtitle="Xero, Google Drive, HubSpot, SharePoint, and more"
    />
  );
}
